<div class="notifications-container">
  <!-- Bell Icon with Badge -->
  <button #bellButton class="notification-bell" (click)="toggleDropdown()" [attr.aria-label]="translation.Notifications.Title | translate">
    <svg width="22" height="22" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.5535 14.1617L20.6535 7.32569C20.0966 5.32302 18.8863 3.56398 17.2149 2.32816C15.5435 1.09234 13.5069 0.450677 11.429 0.505157C9.35104 0.559637 7.35093 1.30714 5.74658 2.62884C4.14224 3.95054 3.02572 5.77059 2.57452 7.79969L1.10352 14.4147C0.941032 15.1456 0.944789 15.9037 1.11451 16.633C1.28423 17.3623 1.61558 18.0442 2.0841 18.6282C2.55262 19.2123 3.14634 19.6837 3.82143 20.0076C4.49652 20.3316 5.23574 20.4997 5.98452 20.4997H7.09852C7.32803 21.63 7.94125 22.6462 8.83426 23.3761C9.72727 24.106 10.8452 24.5047 11.9985 24.5047C13.1519 24.5047 14.2698 24.106 15.1628 23.3761C16.0558 22.6462 16.669 21.63 16.8985 20.4997H17.7365C18.5073 20.4997 19.2677 20.3216 19.9583 19.9791C20.6488 19.6367 21.2509 19.1392 21.7173 18.5256C22.1838 17.9119 22.5021 17.1987 22.6473 16.4417C22.7925 15.6847 22.7598 14.9044 22.5535 14.1617ZM11.9985 22.4997C11.3803 22.4971 10.7779 22.3036 10.2738 21.9456C9.76975 21.5876 9.3886 21.0826 9.18252 20.4997H14.8145C14.6084 21.0826 14.2273 21.5876 13.7232 21.9456C13.2191 22.3036 12.6168 22.4971 11.9985 22.4997ZM20.1245 17.3147C19.8459 17.6844 19.4848 17.9839 19.0701 18.1897C18.6554 18.3954 18.1984 18.5015 17.7355 18.4997H5.98452C5.5353 18.4996 5.09184 18.3987 4.68686 18.2043C4.28188 18.0099 3.92572 17.727 3.64468 17.3766C3.36363 17.0261 3.16488 16.6171 3.06308 16.1795C2.96128 15.742 2.95904 15.2872 3.05652 14.8487L4.52652 8.23269C4.88087 6.6389 5.75782 5.20929 7.01797 4.17114C8.27812 3.13298 9.84914 2.54586 11.4813 2.5031C13.1134 2.46035 14.713 2.96441 16.0258 3.93516C17.3386 4.90591 18.2892 6.28764 18.7265 7.86069L20.6265 14.6967C20.7521 15.1421 20.7721 15.6106 20.6849 16.065C20.5978 16.5195 20.4059 16.9473 20.1245 17.3147Z"
        fill="currentColor" />
    </svg>
    <span *ngIf="unreadCount > 0" class="notification-badge">{{ unreadCount }}</span>
  </button>

  <!-- Dropdown Panel (position: fixed, rendered via ngStyle) -->
  <div class="notification-dropdown" *ngIf="isOpen" [ngStyle]="dropdownStyle">
    <!-- Header -->
    <div class="notification-header">
      <h3>{{ translation.Notifications.Title | translate }}</h3>
      <button *ngIf="unreadCount > 0" class="mark-all-read" (click)="markAllAsRead()">
        {{ translation.Notifications.MarkAllAsRead | translate }}
      </button>
    </div>

    <!-- Notification List -->
    <div class="notification-list">
      <div
        *ngFor="let notification of notifications"
        class="notification-item"
        [class.unread]="!notification.isRead"
        [class.read]="notification.isRead"
        (click)="markAsRead(notification)">
        <div class="notification-indicator" *ngIf="!notification.isRead"></div>
        <div class="notification-content">
          <div class="notification-title">{{ notification.titleKey | translate }}</div>
          <div class="notification-message">{{ notification.messageKey }}</div>
          <div class="notification-time">{{ getTimeAgo(notification.date) }}</div>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="notifications.length === 0" class="notification-empty">
      {{ translation.Notifications.NoNotifications | translate }}
    </div>
  </div>
</div>
